import { getPagePath } from '@spotahome/soyuz/client';
import queryString from 'query-string';

export const getReferrerLink = ({ code, params = {} }) => {
  const baseUrl = window.location.origin;
  const path = getPagePath('referee', {
    params: {
      referrerCode: code
    }
  });
  const query = queryString.stringify(params);
  return `${baseUrl}${path}${query ? `?${query}` : ''}`;
};
